import { c as _c } from "react/compiler-runtime";
import type { CollectDocumentConfig } from '@onefootprint/request-types';
import { useTranslation } from 'react-i18next';
import { DOC_REQUEST_KIND } from '@/idv2/features/collect-document/types';
import type { NonIdDocKinds } from './types';
import getCustomDocInfo from './utils/get-custom-doc-info';
const useDocName = config => {
  const $ = _c(11);
  const docKind = config.kind;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "document-flow.non-id-doc.global.doc-name"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  if (docKind === DOC_REQUEST_KIND.identity || docKind === DOC_REQUEST_KIND.selfie) {
    return "";
  }
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp2);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== config) {
    t3 = getCustomDocInfo(config).documentName || "";
    $[5] = config;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = {
      [DOC_REQUEST_KIND.proofOfAddress]: t1,
      [DOC_REQUEST_KIND.proofOfSsn]: t2,
      [DOC_REQUEST_KIND.custom]: t3
    };
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const docKindToDocName = t4;
  return docKindToDocName[docKind];
};
export default useDocName;
function _temp($) {
  return $["proof-of-address"];
}
function _temp2($_0) {
  return $_0["proof-of-ssn"];
}